import * as React from "react"

import Seo from "components/common/seo/Seo"
import MainLayout from "components/layouts/main_v2/Main"
import Greeting from "pages-blocks/index_v2/Greeting/Greeting"
import Modules from "pages-blocks/index_v2/Modules/Modules"
import ValueAndCustomers from "pages-blocks/index_v2/ValueAndCustomers/ValueAndCustomers"
import Automation from "pages-blocks/index_v2/Automation/Automation"
import CustomerEngagement from "pages-blocks/index_v2/CustomerEngagement/CustomerEngagement"
import QuickActions from "pages-blocks/index_v2/QuickActions/QuickActions"
import CommunicationChannels from "pages-blocks/index_v2/CommunicationChannels/CommunicationChannels"
import Visibility from "pages-blocks/index_v2/Visibility/Visibility"
import Integrations from "pages-blocks/index_v2/Integrations/Integrations"
import ManyMore from "pages-blocks/index_v2/ManyMore/ManyMore"
import TryScope from "pages-blocks/index_v2/TryScope/TryScope"

const IndexPage = () => (
  <MainLayout>
    <Greeting />
    <Modules />
    <ValueAndCustomers />
    <Automation />
    <CustomerEngagement />
    <QuickActions />
    <CommunicationChannels />
    <Visibility />
    <Integrations />
    <ManyMore />
    <TryScope />
  </MainLayout>
)

export const Head = () => (
  <Seo
    title="Scope - Modern Customer Onboarding Software for B2B Companies"
    description="Powerful AI-driven customer implementation platform for SMB and Enterprise onbording"
  >
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_p.webp" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_y.webp" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_e.webp" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_r.webp" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/backgrounds/grad_b.webp" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/screens/dashboard-v2.webp" imageSrcSet="//cdn-platform.scope-dev.ws/website/images/screens/dashboard-v2.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/dashboard-v2@2x.webp 2x" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/screens/cfp.webp" imageSrcSet="//cdn-platform.scope-dev.ws/website/images/screens/cfp.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/cfp@2x.webp 2x" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/screens/sales-room.webp" imageSrcSet="//cdn-platform.scope-dev.ws/website/images/screens/sales-room.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/sales-room@2x.webp 2x" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/screens/library-v2.webp" imageSrcSet="//cdn-platform.scope-dev.ws/website/images/screens/library-v2.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/library-v2@2x.webp 2x" />
    <link rel="preload" as="image" href="//cdn-platform.scope-dev.ws/website/images/screens/templates-v2.webp" imageSrcSet="//cdn-platform.scope-dev.ws/website/images/screens/templates-v2.webp 1x, //cdn-platform.scope-dev.ws/website/images/screens/templates-v2@2x.webp 2x" />
  </Seo>
)

export default IndexPage
